// src/pages/transport-requests/TransportDepartureRequestPage.tsx
import React from "react";
import { Container, Paper, Stack, Title, Text } from "@mantine/core";
import { MantineProvider } from "@mantine/core";
import TransportDepartureRequestStepper from "./TransportDepartureRequestStepper";
import { IconPlaneDeparture, } from "@tabler/icons-react";

export default function TransportDepartureRequestPage() {
    return (
        <Container size="md" py="xl">
            <Paper withBorder p="lg" radius="md">
                <Stack gap="xs">
                    <Title order={3}>{<IconPlaneDeparture size={25} />} Transport Departure request</Title>
                    <Text c="dimmed">
                        Fill in your departure and contact information - and we will register your transport.
                    </Text>
                </Stack>
            </Paper>

            <Paper withBorder p="lg" radius="md" mt="md">
                <MantineProvider
                    theme={{
                        primaryColor: "brand",
                        colors: {
                            brand: [
                                "#ffe5e5",
                                "#ffcaca",
                                "#ff9a9a",
                                "#ff7a7a",
                                "#ff6868",
                                "#ff5e5e",
                                "#f24848",
                                "#e53a3a",
                                "#d92d2d",
                                "#cc2222",
                            ],
                        },
                    }}
                >
                    <TransportDepartureRequestStepper />
                </MantineProvider>
            </Paper>
        </Container>
    );
}